import { useState } from 'react';
import { ArrowUpRight } from 'lucide-react';

export function CoverImage({ src, alt }: { src?: string; alt: string }) {
  const [failed, setFailed] = useState(false);
  const url = src?.trim();
  if (!url || failed) return null;

  return (
    <div className="relative aspect-[16/10] overflow-hidden bg-elevated">
      <img
        src={url}
        alt={alt}
        loading="lazy"
        onError={() => setFailed(true)}
        className="absolute inset-0 h-full w-full object-cover"
      />
    </div>
  );
}

export function ResultPill({ value }: { value?: string }) {
  const text = value?.trim();
  if (!text) return null;
  return <p className="chip border-signal/40 text-signal">{text}</p>;
}

export function UnavailableNotice({ active }: { active?: boolean }) {
  if (!active) return null;
  return (
    <div className="space-y-2">
      <p className="inline-flex rounded-full border border-danger/40 bg-danger/10 px-2.5 py-1 text-xs font-medium text-danger">
        Currently not working
      </p>
      <p className="text-sm text-muted">The live demo is currently unavailable.</p>
    </div>
  );
}

export function LiveLink({ href, label }: { href?: string; label: string }) {
  const url = href?.trim();
  if (!url) return null;
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" className="text-link inline-flex items-center gap-1.5">
      {label}
      <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
    </a>
  );
}
